<template>
  <AcademyHomepage>
    <div class="assignments-page">
      <AssignmentsAndFilesNavigation />
      <div class="d-flex justify-space-between mb-5 assignments-nav-container">
        <div class="d-flex align-center">
          <AddAssignmentItemMenu v-if="isRenderAssignmentMenu" />
          <div class="d-flex align-center ml-5">
            <router-link
              v-for="navigationLink in navigationLinks"
              :key="navigationLink.label"
              to=""
              custom
              @click.native.prevent="
                handleClickStatusLink(navigationLink.status)
              "
              v-slot="{ href, navigate }"
            >
              <AssignmentsAndFilesNavigationLink
                :label="navigationLink.label"
                :href="href"
                :navigate="navigate"
                :isActive="navigationLink.status === currentStatus"
                customClassName="common-tab--assignments"
              />
            </router-link>
          </div>
        </div>
        <div class="storage-search-input">
          <StorageSearchInput
            isAssignmentInput
            :handleSetAssignments="handleSetAssignments"
            :currentStatus="currentStatus"
          />
        </div>
      </div>
      <AssignmentsList
        class="assignments-list"
        :status="currentStatus"
        :searchContextAssignments="assignments"
        :handleStatusChange="handleStatusChange"
      />
    </div>
    <div>
      <CommonDialog
        v-if="isDeleteAssignmentDialogOpened"
        :isDialogOpened="isDeleteAssignmentDialogOpened"
        @handleCloseDialog="
          toggleDeleteAssignmentDialog({
            isDeleteAssignmentDialogOpened: false
          })
        "
        width="400px"
      >
        <DeleteAssignmentModal />
      </CommonDialog>
      <CommonDialog
        v-if="isCloseAssignmentDialogOpened"
        :isDialogOpened="isCloseAssignmentDialogOpened"
        @handleCloseDialog="
          toggleCloseAssignmentDialog({
            isCloseAssignmentDialogOpened: false
          })
        "
        width="400px"
      >
        <CloseAssignmentModal />
      </CommonDialog>
    </div>
  </AcademyHomepage>
</template>

<script>
import AcademyHomepage from "../home/AcademyHomepage";
import AssignmentsAndFilesNavigation from "../common/AssignmentsAndFilesNavigation";
import AddAssignmentItemMenu from "./AddAssignmentItemMenu";
import { Routes } from "../../../router/Routes";
import { i18n } from "../../../plugins/i18n";
import AssignmentsAndFilesNavigationLink from "../common/AssignmentsAndFilesNavigationLink";
import StorageSearchInput from "../storage/form/StorageSearchInput";
import AssignmentsList from "./AssignmentsList";
import CommonDialog from "../common/dialog/CommonDialog";
import DeleteAssignmentModal from "./DeleteAssignmentModal";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { mapGetters, mapMutations } from "vuex";
import CloseAssignmentModal from "./CloseAssignmentModal";
import { AssignmentStatusTypes } from "../enums/AssignmentStatusTypes";

const AssignmentStatus = {
  OPEN: "OPEN",
  COMPLETED: "COMPLETED"
};

export default {
  name: "AssignmentsPage",
  components: {
    DeleteAssignmentModal,
    AssignmentsList,
    StorageSearchInput,
    AddAssignmentItemMenu,
    AssignmentsAndFilesNavigation,
    AcademyHomepage,
    AssignmentsAndFilesNavigationLink,
    CommonDialog,
    CloseAssignmentModal
  },
  data: () => ({
    currentStatus: null,
    navigationLinks: [
      {
        path: Routes.ACADEMY_ASSIGNMENT_ORGANIZATION.path,
        label: i18n.tc("assignments.open"),
        status: AssignmentStatus.OPEN
      },
      {
        path: Routes.ACADEMY_ASSIGNMENT_ORGANIZATION.path,
        label: i18n.tc("assignments.completed"),
        status: AssignmentStatus.COMPLETED
      }
    ],
    assignments: null
  }),
  created() {
    this.currentStatus =
      this.assignmentsListStatus || AssignmentStatusTypes.OPEN;
  },
  computed: {
    ...mapGetters(ModuleTypes.ASSIGNMENTS, [
      "isDeleteAssignmentDialogOpened",
      "isCloseAssignmentDialogOpened",
      "assignmentsListStatus"
    ]),

    ...mapGetters(ModuleTypes.STORAGE, [
      "storageSearchInputValue",
      "isInputFocused"
    ]),

    isRenderAssignmentMenu() {
      return !this.$route.params?.playerId;
    }
  },
  methods: {
    ...mapMutations(ModuleTypes.ASSIGNMENTS, [
      "toggleDeleteAssignmentDialog",
      "toggleCloseAssignmentDialog",
      "setAssignmentItemDetails"
    ]),

    ...mapMutations(ModuleTypes.STORAGE, [
      "setStorageSearchInputValue",
      "setStorageSearchInputFocused",
      "setIsCallSearchRequest"
    ]),

    handleClickStatusLink: function(status) {
      if (this.storageSearchInputValue?.length || this.isInputFocused) {
        this.setIsCallSearchRequest({ isCallSearchRequest: false });
        this.setStorageSearchInputValue("");
        this.setStorageSearchInputFocused(false);
        setTimeout(
          () => this.setIsCallSearchRequest({ isCallSearchRequest: true }),
          1000 // SEARCH DEBOUNCE INTERVAL
        );
      }

      this.setAssignmentItemDetails(null);
      this.currentStatus = status;
    },

    handleSetAssignments(value) {
      this.assignments = value;
    },

    handleStatusChange(value) {
      this.currentStatus = value;
    }
  }
};
</script>

<style scoped>
.assignments-page {
  position: relative;
  //left: -225px;
}

.common-tab--assignments {
  font-size: 0.8rem;
}
@media (max-width: 959px) {
  .storage-search-input {
    flex-basis: 100%;
    margin-top: 0.5vh;
  }
  .assignments-nav-container {
    flex-wrap: wrap;
  }
  .assignments-page {
    left: 0;
  }
}
@media (max-width: 660px) {
  .storage-search-input {
    flex-basis: 100%;
    margin-top: 0.5vh;
  }
}
</style>
